import CasinoBoost from '~/client/features/CasinoBoost';
import Tournaments from '~/client/features/Tournaments';
import GameDetailsTable from '~/client/shared/game/GameDetailsTable';
import LazyLoad from '~/client/shared/LazyLoad';
import usePopover from '~/client/shared/NavBarControls/LoggedOutControls/hooks/usePopover';
import Popover from '~/client/shared/NavBarControls/LoggedOutControls/Popover';
import GameBlock from './GameBlock';
import PlaylistGames from './shared/PlaylistGames';
import useGameContext from '../../context/Game/useGameContext';
import GameDescription from '../shared/GameDescription';

const GameViewDesktop: FC = () => {
  const { game } = useGameContext();
  const { popoverModule, handlePopoverClose } = usePopover();
  return (
    <>
      {!!popoverModule && (
        <Popover module={popoverModule} onClose={handlePopoverClose} />
      )}
      <div className="grid gap-8">
        <Tournaments module="gameBanner" />
        <GameBlock />
        <CasinoBoost module="game" />
        <GameDetailsTable game={game} />
        <LazyLoad>
          <PlaylistGames />
        </LazyLoad>
        <GameDescription />
      </div>
    </>
  );
};

export default GameViewDesktop;
